import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AppConstants } from '../constants/app-constants';
import { UserCacheService } from './user-cache.service';
@Injectable()
export class AuthService {
    constructor(public userCacheService: UserCacheService) { }
    // ...
    private jwtHelper = new JwtHelperService();
    public isAuthenticated(): boolean {
        const token = this.userCacheService.getUserData(AppConstants.TOKEN) ?? '';
        // Check whether the token is expired and return
        // true or false
        return !this.jwtHelper.isTokenExpired(token);
    }
}